import React , { useState , useEffect} from 'react'

import { ApiCallPost } from '../ApiCall/ApiCall';


// showNormal = Solicitamos regresar al estado normal
export default function LoadPhoto( { usuario , id  , index  , myData } ) {

  const [theValues,setTheValues] = useState( [] )
  const [data] = useState( myData )

  //setData( myData )

  useEffect(() => {
    console.log( "myDate en LoadPhoto = " , data )
  }, [data])


  useEffect(() => {
    console.log("Index =  ", index)
  

  },[index])

  useEffect (() => {

    if ( theValues == null )
    {
      return ;
    }

    console.log("theValues = ", theValues)

    console.log("theValues.length = ", theValues.length)
  },[theValues])

  


    // sol1824M  , 040083


    // 013785 = usuario  // 638416 = folio

    function getDisplay( index )
    {
      if ( index == null )
      {
        return ""
      }

      return (
        <>
          Celular : {data[index].celular} FolioSisact : {data[index].folioSisact}
        </>
      )

    }
    
    function preImage( file )
    {
        console.log( "preImage") ;
        
        if ( !file || file.length === 0 )
        {
          setTheValues( [] )
          return ;
        }

        const promises = Array.from(file).map((oneFile, idx) => {
          console.log( "file = " + oneFile.name)

          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(oneFile)
            reader.onloadend = function() {
              const base64 = reader.result;
              
              console.log( "id = " , data[index].idmsgseg )
              
              var values = {
                nSec : idx + 1 ,
                idMsgSeg : data[index].idmsgseg,
                image: base64 === "{}" ? null : base64 ,
                longitud : "0",
                latitud : "0" ,
                dTimeStamp: new Date()
              } ;
              
              resolve(values)
            }
            reader.onerror = function() {
              reject(new Error("No se pudo leer la imagen " + oneFile.name))
            }
          })
        })
        
        Promise.all(promises)
        .then((valArray) => {
          console.log("valArray agregando = ", valArray.length )
          setTheValues( valArray )
        })
        .catch((err) => {
          console.log(err)
          alert("Error al preparar imagenes")
          setTheValues([])
        })
    }

    async function uploadImages(  )
    {

        if ( theValues == null || theValues.length === 0 )
        {
          alert("No hay imagen seleccionada")
          return
        }
      
        console.log("uploadImages " + theValues.length  )

        try
        {
          for( let i = 0 ; i < theValues.length ; i++ )
          {
            console.log( "Solicitando carga de " + i )
            await uploadImage( theValues[i] , i )
          }

          setTheValues( [] )  
          alert("Imagenes subidas correctamente")
        }
        catch(err)
        {
          console.log(err)
          alert("Error al subir una o mas imagenes")
        }
    
    }

    async function uploadImage( payload , id ){
      const result = await ApiCallPost( "evidence" , payload )
      console.log("Result = " + result)

      if ( result !== "ok" )
      {
        throw new Error("Respuesta invalida del servidor")
      }

      console.log("Se subio imagen  = ", id)
      return "ok"
    }

  return (
    <>
      <div>Subir Foto(s) {getDisplay(index)}  </div>
        <input type='file' className="btn btn-primary mt-3 button-3"
          onChange={(event=>preImage(event.target.files))} multiple={true} accept='image/*'></input>
        <button className="btn btn-primary mt-3 button-3" onClick={uploadImages}>Subir imagen</button>
    </>
    
  )
}
